module.exports = __webpack_public_path__ + "static/marche-ac87175f4a99c501983045545ce4ec54.eot";